import React, { useEffect, useState } from 'react'
import { isMobileOnly } from 'react-device-detect'
import { useSelector } from 'react-redux'

import Tooltip2 from 'components/common/Tooltip2.0'
import useLocalAudioToggle from 'hooks/useLocalAudioToggle/useLocalAudioToggle'
import { dispatchUpdateParticipantInfo } from 'store/dispatcher/Room'
import { _userId } from 'store/selectors/User'
import { logger } from 'utils/logger'

import { BtnWrapper, Button, MenuIcon } from '../styles'

const ICON_BASE = '/assets/revamp'

const ToggleAudioButton = props => {
    const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle()
    const userId = useSelector(_userId)

    useEffect(() => {
        dispatchUpdateParticipantInfo(userId, 'isAudioEnabled', isAudioEnabled)

        logger.info(`user audio status : ${isAudioEnabled ? 'on' : 'off'}`)
    }, [isAudioEnabled])

    const [blockAudioTimerAnim, setBlockAudioTimerAnim] = useState(false)
    useEffect(() => {
        blockAudioTimerAnim && setBlockAudioTimerAnim(false)
    }, [blockAudioTimerAnim])

    const tooltipProps = {
        content: isAudioEnabled ? 'mute audio' : 'unmute audio',
        placement: 'top',
    }

    const btnProps = {
        onClick: () => {
            if (blockAudioTimerAnim) return
            toggleAudioEnabled()
            setBlockAudioTimerAnim(true)
        },
        disabled: props.disabled,
        'data-cy-audio-toggle': true,
        clicked: !isAudioEnabled,
        isMobile: isMobileOnly,
    }

    const menuIconProps = {
        src: `${ICON_BASE}/${isAudioEnabled ? 'mic-on.svg' : 'mic-off.svg'}`,
        clicked: !isAudioEnabled,
        alt: 'menu',
    }

    console.count('ToggleAudioButton Component')

    return (
        <>
            <Tooltip2 {...tooltipProps}>
                <BtnWrapper disabled={blockAudioTimerAnim}>
                    <Button {...btnProps}>
                        <MenuIcon {...menuIconProps} />
                    </Button>
                </BtnWrapper>
            </Tooltip2>
        </>
    )
}

export { ToggleAudioButton }
